export default __webpack_public_path__ + "static/media/badguy-css.2069ca44.jpg";